import { render, staticRenderFns } from "./RecordConfig.vue?vue&type=template&id=38116d9e&scoped=true"
import script from "./RecordConfig.vue?vue&type=script&lang=js"
export * from "./RecordConfig.vue?vue&type=script&lang=js"
import style0 from "./RecordConfig.vue?vue&type=style&index=0&id=38116d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38116d9e",
  null
  
)

export default component.exports